module.exports = __webpack_public_path__ + "media/images/404_icon-16b53606.png";